import * as OFMSUI from "react-bootstrap"; import "bootstrap/dist/css/bootstrap.min.css"; import { Field, useFormik, FormikProvider, ErrorMessage } from "formik";
import * as Yup from "yup"; import React, { useState } from "react"; import { Form } from "react-bootstrap";
import Swal from "sweetalert2/dist/sweetalert2.js"; import HousingService from "../../../Services/HousingService"; import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { DashboardServiceReport, generatePDF, LabelHeader, ModuleHeader, NumberValidation, SubmitButton, todayDate } from "../../utils/commonFunctions"; import { store } from "../../../App";
import ShowAlert from "../../alert";
import { Table } from "react-bootstrap"; import { AiOutlineSearch } from "react-icons/ai"; import { MdOutlinePictureAsPdf } from "react-icons/md"; import ReactHTMLTableToExcel from "react-html-table-to-excel";

const OutstandingReceipts = () => {
  const [bankNamesList, setbankNamesList] = useState([]); const [district, setindistrict] = useState([]); const [brsPaymentsData, setbrsPaymentsData] = useState([]);
  const [showTable, setShowTable] = useState(false); const [search, setSearch] = useState(""); const [selectedBrsPaymentsList, setSelectedBrsPaymentsList] = useState([]); const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  const validationSchema = Yup.object().shape({ bankname: Yup.string().required("required") });
  const formik = useFormik({
    initialValues: {
      bankname: "", rows: [{ date: '', amount: '', checkbox: '' }]
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let params = { brsBanknameaccountno: values.bankname, brsTransaction_type: 'R' }
      store.dispatch({ type: "SHOW_SPINNER" });
      HousingService.getBRSOutstanding(params).then((res) => {
        if (res && res.data && res.data?.length > 0) { setbrsPaymentsData(res.data); } else { setbrsPaymentsData([]); }
      }).catch((error) => {
        ShowAlert("Some error occured", "error"); console.log(error);
      }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); setShowTable(true); })
    }
  });

  React.useEffect(() => {
    HousingService.fetchBank().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          if (item !== null) { return (<option key={i} value={item.banknameaccountno}> {item.banknameaccountno} </option>); }
        });
        setbankNamesList(options);
      }
    });

    HousingService.fetchDistrictNames().then((res) => {
      const response = res.data[0].display_name;
      const username = localStorage.getItem("username");
      if (res.data) {
        if (username && username.includes("DH")) { const district = response; setindistrict(district); } else { setindistrict(response); }
      }
    });

  }, []);
  const handleSearch = event => { setSearch(event.target.value) }

  const filteredData = search.length > 0 ? brsPaymentsData?.filter((item) => {
    return (
      item && Object.keys(item).some((key) => {
        const value = item[key];
        return (
          value !== null && value.toString().toLowerCase().includes(search.toLowerCase()));
      }));
  }) : brsPaymentsData;

  const handleCheckboxChange = (event, detail, i) => {
    const selected = event.target.checked;
    setSelectedCheckboxes((prevSelectedCheckboxes) => {
      if (selected) { return [...prevSelectedCheckboxes, detail.payment_receipt_id]; } else { return prevSelectedCheckboxes.filter((value) => value !== detail.payment_receipt_id); }
    });
    setSelectedBrsPaymentsList((prevList) => {
      if (selected) {
        return [
          ...prevList,
          { brsBanknameaccountno: detail.banknameaccountno, brsPaymentreceiptid: detail.payment_receipt_id, brsChequeddreceiptno: detail.cheque_dd_receipt_no, brsTransaction_type: detail.transaction_type, brsBankdate: formik.values.rows[i]?.date, brsAmount: parseFloat(formik.values.rows[i]?.amount), },
        ];
      } else { return prevList.filter((value) => value.payment_receipt_id !== detail.payment_receipt_id); }
    });
  };

  const handleDateChange = (event, originalIndex) => {
    const { value } = event.target;
    if (value) { const amount = filteredData[originalIndex].amount; formik.setFieldValue(`rows[${originalIndex}].date`, value); formik.setFieldValue(`rows[${originalIndex}].amount`, amount); }
  };

  const submitListBRS = () => {
    console.log("selectedBrsPaymentsList:", selectedBrsPaymentsList);
    if (selectedBrsPaymentsList.length > 0) {
      Swal.fire({ text: "Are You Sure Want to Submit?", icon: "question", showCancelButton: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", confirmButtonText: "Yes", }).then((result) => {
        if (result.isConfirmed) {
          store.dispatch({ type: "SHOW_SPINNER" });
          let params = selectedBrsPaymentsList;
          HousingService.BankBookUpdateInsertion(params).then((res) => {
            if (res.data.responseToken === "1") { ShowAlert(res.data.responseMessage, "success").then(function (isConfirm) { if (isConfirm.value) { history.go(0); } }); } else { ShowAlert(res.data.responseMessage, "error") }
          }).catch((error) => { ShowAlert("Some error occcured", "error"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
        }
      });
    } else { ShowAlert("Please select atleast one", "warning"); }
  }
  return (
    <>
      <NavigationServicesHeader />
      <ModuleHeader title="Outstanding Receipts" />
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
        <FormikProvider value={formik}> <Form onSubmit={formik.handleSubmit}> <DashboardServiceReport title="Service" />
          <OFMSUI.Row className="mb-3"> <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}> <OFMSUI.InputGroup className=" mt-4"> <span className="label-text-style"> <b>District Name</b> </span> <div className="emptyspace3">{district}</div> </OFMSUI.InputGroup> </OFMSUI.Col> <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > <LabelHeader title="Bank" /> <Field component="select" name="bankname" className={formik.touched.bankname && formik.errors.bankname ? "form-control is-invalid" : "form-control"} > <option value="">Select</option> {bankNamesList} </Field> <ErrorMessage name="bankname" component={"div"} className="text-error" /> </OFMSUI.Col> </OFMSUI.Row>
          <SubmitButton title="Get Details" />
          {showTable && (
            <>
              <OFMSUI.Row> <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=' mb-3' > <div className='input-group'> <div className='input-group-prepend'> <div className='input-group-text group_txt11' id='btnGroupAddon' > <AiOutlineSearch /> </div> </div> <input type='text' id='#filterInput' placeholder='Search ' style={{ width: '25%' }} className='form-control input-lg' value={search} onChange={handleSearch} ></input> </div> </OFMSUI.Col>
                <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=' mb-2 float-end' >
                  <button type='button' className='btn btn-success btn-sm' style={{ float: 'right', color: '#fff', marginLeft: '3px' }} > <ReactHTMLTableToExcel id='my-table-xls-button' className='download-table-xls-button' table='my-table' filename='OutstandingReceipts' sheet='tablexls' buttonText='Excel' /> </button> <button className='btn btn-danger btn-sm' type='button' style={{ float: 'right', marginLeft: '3px' }} onClick={() => generatePDF("my-table", "Outstanding Receipts", "OutstandingReceipts.pdf", 5)}> PDF <MdOutlinePictureAsPdf /> </button>
                </OFMSUI.Col>
              </OFMSUI.Row>
              <div style={{ overflow: "auto", height: "500px" }}>
                <Table striped bordered hover id="my-table" style={{ width: "100%" }}>
                  <thead className="fw-bold" style={{ top: "0px", position: "sticky" }}>
                    <tr className="" style={{ textAlign: "center" }}><th colSpan={6}>As per Corporation</th><th colSpan={3}>As per Bank</th></tr>
                    <tr className="table_countshead"> <th>S.No.</th> <th>Date</th> <th>Inst No.</th> <th>Amount</th> <th style={{ textAlign: "center" }}>Clearance Date</th> <th style={{ textAlign: "center" }}>Amount</th> <th style={{ textAlign: "center" }}>Action</th> </tr>
                  </thead>
                  <tbody>
                    {filteredData?.length === 0 || filteredData === undefined ? (<tr> <td colSpan={7} style={{ fontSize: "15px", textAlign: "center" }}> No details found </td> </tr>) : (
                      filteredData.map((detail, i) => {
                        const originalIndex = brsPaymentsData.findIndex(d => d.payment_receipt_id === detail.payment_receipt_id)
                        return (
                          <tr key={originalIndex}>
                            <td>{originalIndex + 1}</td>
                            <td>{detail?.date}</td>
                            <td>{detail?.cheque_dd_receipt_no}</td>
                            <td>{detail?.amount}</td>
                            <td><Field type="date" name={`rows[${originalIndex}].date`} className="form-control input" max={todayDate} onChange={(event) => handleDateChange(event, originalIndex)} /></td>
                            <td><Field type="text" name={`rows[${originalIndex}].amount`} className="form-control input" onKeyPress={(e) => NumberValidation(e)} maxLength={15} /></td>
                            <td> <center> <input type="checkbox" name={`rows[${originalIndex}].checkbox`} value={detail.payment_receipt_id} onChange={(event) => handleCheckboxChange(event, detail, originalIndex)} checked={selectedCheckboxes.includes(detail.payment_receipt_id)} disabled={ formik.values.rows[originalIndex]?.date === "" || formik.values.rows[originalIndex]?.date === null || formik.values.rows[originalIndex]?.date === undefined || formik.values.rows[originalIndex]?.amount === "" || formik.values.rows[originalIndex]?.amount === null || formik.values.rows[originalIndex]?.amount === undefined } /> </center> </td>
                          </tr>
                        )
                      })
                    )}
                  </tbody>
                </Table>
              </div>
              <div style={{ textAlign: "center", marginTop: "20px" }}> <button type="button" onClick={() => submitListBRS()} className="btn btn-success sm"> Submit </button> </div>

            </>
          )}




        </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  )
}

export default OutstandingReceipts
